<template>
  <div class="pb-3">
    <va-card :title="$t(`sendNotification.title`)">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(send)">
          <div class="row">
            <div class="flex md12">
              <ValidationProvider rules="required" name="Titulo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="live.title"
                  :label="$t('sendNotification.forms.titleLabel')"
                  :placeholder="$t('sendNotification.forms.titlePlaceholder')"
                  :success="errors.length == 0 && live.title.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="Corpo da Mensagem" v-slot="{ errors }">
                <va-input
                  v-model="live.subtitle"
                  :label="$t('sendNotification.forms.bodyLabel')"
                  :placeholder="$t('sendNotification.forms.bodyPlaceholder')"
                  :success="errors.length == 0 && live.subtitle.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <ValidationProvider rules="required" name="URL" v-slot="{ errors }">
                <va-input
                  v-model="live.url"
                  :label="$t('transmissions.forms.urlLabel')"
                  :placeholder="$t('transmissions.forms.urlPlaceholder')"
                  :success="errors.length == 0 && live.url.length > 0"
                  :error="errors.length > 0"
                  :error-messages="errors"
                />
              </ValidationProvider>
              <div v-if="imageUrl" class="form-group mb-2">
                <label>{{ $t('sendNotification.forms.imageLabel') }}</label>
                <div class="mt-1">
                  <img
                    :src="imageUrl"
                    alt="Preview da Thumbnail"
                    style="max-width: 100%; max-height: 180px; border-radius: 6px; object-fit: cover; display: block; border: 1px solid #e0e0e0;"
                  />
                </div>
              </div>
              <label>{{$t('transmissions.forms.isPrivatePlaceholder')}}</label>
              <va-toggle
                v-model="live.is_private"
                small
                :label="live.is_private ? 'Sim' : 'Não'"
              />
            </div>
            <div class="d-flex mt-1">
              <va-button
                type="submit"
                :disabled="buttonSubmitDisabled"
                color="success"
                class="my-0">
                {{ textSubmit }}
              </va-button>
              <va-button
                type="button"
                class="my-0"
                color="danger"
                @click="cancel">
                {{ $t("forms.cancel") }}
              </va-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </va-card>
  </div>
</template>

<script>
export default {
  name: 'sendNotification',
  props: {
    sendData: {
      required: true,
    },
  },
  data () {
    return {
      live: {
        title: '',
        subtitle: '',
        url: '',
        is_private: false,
        thumbnail: '',
      },
      buttonSubmitDisabled: false,
      textSubmit: this.$t('forms.send'),
    }
  },
  computed: {
    imageUrl () {
      if (!this.live || !this.live.thumbnail) return ''
      if (this.live.thumbnail.includes('http')) {
        return this.live.thumbnail
      }
      const cdn = (this.$store.getters['environment/cdn'] || 'https://cdn.s1live.com').replace(/\/+$/, '')
      return `${cdn}/thumbnail/${this.live.thumbnail}`
    },
  },
  mounted () {
    this.live.title = ''
    this.live.subtitle = ''
    this.live.url = ''
    this.live.is_private = ''
    this.live.thumbnail = ''
    if (this.sendData !== null) {
      this.transmission_get(this.sendData)
    }
  },
  methods: {
    cancel () {
      this.$emit('close', false)
    },
    transmission_get (data) {
      Object.keys(data).forEach((value, _) => {
        if (value === 'title') {
          this.live[value] = data[value]
        } else if (value === 'description') {
          this.live.subtitle = data[value]
        } else if (value === 'url') {
          this.live[value] = data[value]
        } else if (value === 'is_private') {
          this.live[value] = data[value]
        } else if (value === 'thumbnail') {
          this.live.thumbnail = data[value]
        }
      })
    },
    send () {
      this.buttonSubmitDisabled = true
      this.textSubmit = this.$t('forms.sending')
      const self = this
      this.$axios.post(
        '/api/messaging/live',
        {
          title: this.live.title,
          body: this.live.subtitle,
          url: this.live.url,
          is_private: this.live.is_private,
          image: this.live.thumbnail,
        },
      ).then(response => {
        self.buttonSubmitDisabled = false
        self.textSubmit = self.$t('forms.send')
        self.$emit('close', false)
        self.showToast(
          self.$t('toasts.successSend'),
          {
            icon: 'fa-check',
            position: 'top-right',
            duration: 1000,
            fullWidth: false,
          },
        )
      })
        .catch(e => {
          self.buttonSubmitDisabled = false
          self.textSubmit = self.$t('forms.send')
          self.showToast(
            self.$t('toasts.errorSend'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
}
</script>
